/**
 * Created by d.penning on 04.10.2017.
 */
export const VIDEO_PLAYER_PLAY = 'VIDEO_PLAYER_PLAY'
export const VIDEO_PLAYER_STOP = 'VIDEO_PLAYER_STOP'
export const VIDEO_PLAYER_CREATE = 'VIDEO_PLAYER_CREATE'
export const VIDEO_PLAYER_DESTROY = 'VIDEO_PLAYER_DESTROY'
export const VIDEO_PLAYER_ACTION = 'VIDEO_PLAYER_ACTION'

export const UPDATE_TIMINGS = 'UPDATE_TIMINGS'
export const UPDATE_MATCH_EVENTS = 'UPDATE_MATCH_EVENTS'

export const INIT_APPLICATION_FINISHED = 'INIT_APPLICATION_FINISHED'
export const INIT_APPLICATION_STARTED = 'INIT_APPLICATION_STARTED'
export const INIT_APPLICATION_FAILED = 'INIT_APPLICATION_FAILED';

export const BETSTOP_CHANGE = 'BETSTOP_CHANGE'

export const CHANGE_ODD_TYPE = 'CHANGE_ODD_TYPE'

export const CUSTOMER_METHODS_CLOSE_EVENT = 'closeEvent'
export const CUSTOMER_METHODS_OPEN_EVENT = 'openEvent'

export const CUSTOMER_METHODS_PLACE_BETS = 'placeBets'
export const CUSTOMER_METHODS_SWITCH_EVENTS = 'switchEvents'
export const BWG_METHODS_SWITCH_COMPETITOR = 'switchCompetitor'
export const CUSTOMER_METHODS_SEND_CURRENT_PHASE_DATA = 'sendCurrentPhaseData';
export const CUSTOMER_METHODS_SWITCH_ALL_EVENTS = 'switchAllEvents'
export const CUSTOMER_METHODS_PHASE_CHANGE = 'phaseChange'
export const CUSTOMER_METHODS_SEEK_EVENTS = 'seekEvents'
export const CUSTOMER_METHODS_SET_HEIGHT = 'setHeight'
export const CUSTOMER_METHODS_OPEN_COMPETITOR_STATS = 'openCompetitorStats'
export const CUSTOMER_METHODS_OPEN_EVENT_STATS = 'openEventStats'
export const CUSTOMER_METHODS_GET_COMPETITOR_IMAGE = 'getCompetitorImage'

export const REQUEST_CURRENT_DATA = 'REQUEST_CURRENT_DATA'
export const REQUEST_CURRENT_PHASE_DATA = 'REQUEST_CURRENT_PHASE_DATA';
export const PREPARE_CURRENT_DATA = 'prepareCurrentData'
export const CUSTOM_INTERNAL_DATA = 'customInternalData'

export const CAROUSEL_AUTOMODE_TOGGLE = 'CAROUSEL_AUTOMODE_TOGGLE'
export const CAROUSEL_AUTOMODE_START = 'CAROUSEL_AUTOMODE_START'
export const CAROUSEL_AUTOMODE_STOP = 'CAROUSEL_AUTOMODE_STOP'
export const CAROUSEL_MANUALMODE_TOGGLE = 'CAROUSEL_MANUALMODE_TOGGLE'
export const CAROUSEL_MANUALMODE_START = 'CAROUSEL_MANUALMODE_START'
export const CAROUSEL_MANUALMODE_STOP = 'CAROUSEL_MANUALMODE_STOP'
export const CAROUSEL_INDEX_CHANGE = 'CAROUSEL_INDEX_CHANGE'
export const CAROUSEL_CONTENT_CHANGE = 'CAROUSEL_CONTENT_CHANGE'
export const CAROUSEL_CONTENT_NAME_SET = 'CAROUSEL_CONTENT_NAME_SET'

export const OVERLAY_TOGGLE = 'OVERLAY_TOGGLE'
export const OVERLAY_SHOW = 'OVERLAY_SHOW'
export const OVERLAY_HIDE = 'OVERLAY_HIDE'
export const STATISTIC_CENTER_OPEN = 'STATISTIC_CENTER_OPEN'

export const FETCH_MATCH_GET_REQUESTED = 'FETCH_MATCH_GET_REQUESTED'
export const FETCH_MATCH_GET_SUCCEEDED = 'FETCH_MATCH_GET_SUCCEEDED'
export const FETCH_MATCH_GET_FAILED = 'FETCH_MATCH_GET_FAILED'

export const FETCH_MATCH_ODDS_REQUESTED = 'FETCH_MATCH_ODDS_REQUESTED'
export const FETCH_MATCH_ODDS_SUCCEEDED = 'FETCH_MATCH_ODDS_SUCCEEDED'
export const FETCH_MATCH_ODDS_FAILED = 'FETCH_MATCH_ODDS_FAILED'

export const FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED = 'FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED'
export const FETCH_STATS_TEAM_VERSUS_RECENT_SUCCEEDED = 'FETCH_STATS_TEAM_VERSUS_RECENT_SUCCEEDED'
export const FETCHING_STATS_ABORTED = 'FETCHING_STATS_ABORTED'
export const FETCH_STATS_TEAM_VERSUS_RECENT_FAILED = 'FETCH_STATS_TEAM_VERSUS_RECENT_FAILED'


export const FETCH_STATS_TEAM_LAST_X_REQUESTED = 'FETCH_STATS_TEAM_LAST_X_REQUESTED'
export const FETCH_STATS_TEAM_LAST_X_SUCCEEDED = 'FETCH_STATS_TEAM_LAST_X_SUCCEEDED'
export const FETCH_STATS_TEAM_LAST_X_FAILED = 'FETCH_STATS_TEAM_LAST_X_FAILED'

export const FETCH_STATS_PLAYER_AGGREGATE_REQUESTED = 'FETCH_STATS_PLAYER_AGGREGATE_REQUESTED';
export const FETCH_STATS_PLAYER_AGGREGATE_SUCCEEDED = 'FETCH_STATS_PLAYER_AGGREGATE_SUCCEEDED';
export const FETCH_STATS_PLAYER_AGGREGATE_FAILED = 'FETCH_STATS_PLAYER_AGGREGATE_FAILED';

export const FETCH_STATS_RANKING_REQUESTED = 'FETCH_STATS_RANKING_REQUESTED'
export const FETCH_STATS_RANKING_SUCCEEDED = 'FETCH_STATS_RANKING_SUCCEEDED'
export const FETCH_STATS_RANKING_FAILED = 'FETCH_STATS_RANKING_FAILED'

export const TRIGGER_FAKED_USER_ACTIONS = 'TRIGGER_FAKED_USER_ACTIONS'

export const FETCH_TIMINGS_REQUESTED = 'FETCH_TIMINGS_REQUESTED'
export const FETCH_TIMINGS_SUCCEEDED = 'FETCH_TIMINGS_SUCCEEDED'
export const FETCH_TIMINGS_FAILED = 'FETCH_TIMINGS_FAILED'

export const CHANGE_CHANNEL = 'CHANGE_CHANNEL'
export const TOGGLE_QUICK_BETTING = 'TOGGLE_QUICK_BETTING'
export const IS_QUICK_BETS_ACTIVE = 'IS_QUICK_BETS_ACTIVE'

export const FETCH_STATIC_TEXT = 'FETCH_STATIC_TEXT';

export const FETCH_PLAYER_STATS_REQUESTED = 'FETCH_PLAYER_STATS_REQUESTED'
export const FETCH_PLAYER_STATS_SUCCEEDED = 'FETCH_PLAYER_STATS_SUCCEEDED'
export const FETCH_PLAYER_STATS_FAILED = 'FETCH_PLAYER_STATS_FAILED'

export const FETCH_PHASES_REQUESTED = 'FETCH_PHASES_REQUESTED'
export const FETCH_PHASES_SUCCEEDED = 'FETCH_PHASES_SUCCEEDED'
export const FETCH_PHASES_FAILED = 'FETCH_PHASES_FAILED'

export const PHASE_CHANGE = 'PHASE_CHANGE'
export const PHASE_CHANGE_ON_ACTIVE_CHANNEL = 'PHASE_CHANGE_ON_ACTIVE_CHANNEL'

export const FETCH_BOOKMAKER_OPTIONS_REQUESTED = 'FETCH_BOOKMAKER_OPTIONS_REQUESTED'
export const FETCH_BOOKMAKER_OPTIONS_SUCCEDED = 'FETCH_BOOKMAKER_OPTIONS_SUCCEDED'
export const FETCH_BOOKMAKER_OPTIONS_FAILED = 'FETCH_BOOKMAKER_OPTIONS_FAILED'

export const FETCH_TRANSLATIONS_REQUESTED = 'FETCH_TRANSLATIONS_REQUESTED'
export const FETCH_TRANSLATIONS_SUCCEEDED = 'FETCH_TRANSLATIONS_SUCCEEDED'
export const FETCH_TRANSLATIONS_FAILED = 'FETCH_TRANSLATIONS_FAILED'

export const FETCH_SCOUT_OPTIONS_REQUESTED = 'FETCH_SCOUT_OPTIONS_REQUESTED'
export const FETCH_SCOUT_OPTIONS_SUCCEDED = 'FETCH_SCOUT_OPTIONS_SUCCEDED'
export const FETCH_SCOUT_OPTIONS_FAILED = 'FETCH_SCOUT_OPTIONS_FAILED'

export const FETCH_MATCH_EVENTS_REQUESTED = 'FETCH_MATCH_EVENTS_REQUESTED'
export const FETCH_MATCH_EVENTS_SUCCEEDED = 'FETCH_MATCH_EVENTS_SUCCEEDED'
export const FETCH_MATCH_EVENTS_FAILED = 'FETCH_MATCH_EVENTS_FAILED'

export const FETCH_MATCH_EVENTS_DELTA_REQUESTED = 'FETCH_MATCH_EVENTS_DELTA_REQUESTED'
export const FETCH_MATCH_EVENTS_DELTA_SUCCEEDED = 'FETCH_MATCH_EVENTS_DELTA_SUCCEEDED'
export const FETCH_MATCH_EVENTS_DELTA_FAILED = 'FETCH_MATCH_EVENTS_DELTA_FAILED'

export const FETCH_MATCH_DETAILS_EXTENDED_REQUESTED = 'FETCH_MATCH_DETAILS_EXTENDED_REQUESTED';
export const FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED = 'FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED';
export const FETCH_MATCH_DETAILS_EXTENDED_FAILED    = 'FETCH_MATCH_DETAILS_EXTENDED_FAILED';

export const PROPAGATE_COUNTDOWN_BY_CHANNEL = 'PROPAGATE_COUNTDOWN_BY_CHANNEL';

export const FETCH_MATCH_FEEDS_REQUESTED = 'FETCH_MATCH_FEEDS_REQUESTED';
export const FETCH_MATCH_FEEDS_SUCCEEDED = 'FETCH_MATCH_FEEDS_SUCCEEDED';
export const FETCH_MATCH_FEEDS_FAILED = 'FETCH_MATCH_FEEDS_FAILED';

export const MATCH_PURGE = 'MATCH_PURGE';
export const ONE_THOUSAND_MILLISECONDS = 1000;

export const FOCUSMATCHSTATUS_VALIDATED = 'FOCUSMATCHSTATUS_VALIDATED';

export const PAUSE_APP = 'PAUSE_APP';
export const RESUME_APP = 'RESUME_APP';
